import request from '@/utils/request'
const api = {
  getChatList: 'chat/getChatList',
  getMsgList: 'chat/getMsgList',
  getChatInfo: 'chat/getChatInfo',
  sendMessage: 'chat/sendMessage',
  readMsg: 'chat/readMsg',
  delChat: 'chat/delChat',
  receive: 'chat/receive'
}
export default {
  receive(parameter) {
    return request({
      url: api.receive,
      method: 'POST',
      data: parameter
    })
  },
  readMsg(parameter) {
    return request({
      url: api.readMsg,
      method: 'post',
      data: parameter
    })
  },
  delChat(parameter) {
    return request({
      url: api.delChat,
      method: 'post',
      data: parameter
    })
  },
  getChatList(parameter) {
    return request({
      url: api.getChatList,
      method: 'post',
      data: parameter
    })
  },
  sendMessage(parameter) {
    return request({
      url: api.sendMessage,
      method: 'post',
      data: parameter
    })
  },
  getMsgList(parameter) {
    return request({
      url: api.getMsgList,
      method: 'post',
      data: parameter
    })
  },
  getChatInfo(parameter) {
    return request({
      url: api.getChatInfo,
      method: 'post',
      data: parameter
    })
  }
}
